module.exports = __webpack_public_path__ + "img/monitor_1.29dafd4f.png";